<div
  class="modal fade show custom_popup"
  tabindex="-1"
  role="dialog"
>
  <div class="modal-dialog width-563" role="document">
    <div class="modal-content add-investor">
      <div class="modal-header justify-content-between">
        <div class="toggle-header d-flex align-items-center gap-2">
          <h5 class="modal-title">
            Add Investor
          </h5>
          <ng-toggle
            [value]="toggleSettings.values"
            [width]="isPerson ? 72 : 105"
            [height]="20"
            [labels]="toggleSettings.labels"
            [switchColor]="toggleSettings.switchColor"
            [color]="toggleSettings.color"
            [values]="toggleSettings.values"
            [fontColor]="toggleSettings.fontColor"
            (valueChange)="toggleChange($event)"
          />
        </div>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          (click)="closeModal()"
        >
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body padding-model form-editing">

        <div class="row">
          <div class="col-lg-12 p-0">
            <div class="card w-100">
              <div class="card">
                <form [formGroup]="investorForm" (ngSubmit)="onSubmit()" class="pl-2">
                  <div class="row">

                    <div *ngIf="!isPerson" class="mb-1 field-group width-280">
                      <label for="organization" class="form-title"><span class="required">*</span> Organization</label>
                      <input type="text" class="form-control" formControlName="firstName" id="organization" />
                      <app-form-error-component [control]="investorForm.controls['firstName']" />
                    </div>

                    <div *ngIf="isPerson" class="mb-1 field-group width-125">
                      <label for="firstName" class="form-title"
                      > <span class="required">*</span> First Name</label>
                      <input type="text" maxlength="15" class="form-control" formControlName="firstName" id="firstName" />
                      <app-form-error-component [control]="investorForm.controls['firstName']" />
                    </div>


                    <div *ngIf="isPerson" class="mb-1 field-group width-125">
                      <label for="lastName" class="form-title"> <span class="required">*</span> Last Name</label>
                      <input type="text" maxlength="15" class="form-control" formControlName="lastName" id="lastName" />
                      <app-form-error-component [control]="investorForm.controls['lastName']" />
                    </div>

                    <div class="mb-1 field-group" [ngClass]="isPerson ? 'width-180' : 'width-245'">
                      <label for="email" class="form-title"> <span class="required">*</span> Email</label>
                      <input type="text" class="form-control" formControlName="email" id="email" />
                      <app-form-error-component [control]="investorForm.controls['email']" />
                    </div>

                    <div *ngIf="isPerson" class="mb-1 field-group width-100">
                      <label for="dob" class="form-title"> Date of Birth </label>
                      <div>
                        <app-date-picker id="dob" formControlName="birthDate" />
                        <app-form-error-component [control]="investorForm.controls['birthDate']" />
                      </div>
                    </div>

                    <div class="mb-1 field-group width-175">
                      <label for="lineOne" class="form-title"> <span class="required">*</span> Address</label>
                      <input type="text" maxlength="25" class="form-control" formControlName="lineOne" id="lineOne" />
                      <app-form-error-component [control]="investorForm.controls['lineOne']" />
                    </div>

                    <div class="mb-1 field-group width-175">
                      <label for="lineTwo" class="form-title"> </label>
                      <input type="text" maxlength="25" class="form-control" formControlName="lineTwo" id="lineTwo" />
                      <app-form-error-component [control]="investorForm.controls['lineTwo']" />
                    </div>


                    <div class="mb-1 field-group width-175">
                      <label for="city" class="form-title"> <span class="required">*</span> City</label>
                      <input type="text" maxlength="15" class="form-control" formControlName="city" id="city" />
                      <app-form-error-component [control]="investorForm.controls['city']"></app-form-error-component>
                    </div>

                    <div class="mb-1 field-group width-175">
                      <label for="state" class="form-title"><span class="required">*</span> County</label>
                      <input type="text" class="form-control" formControlName="state" id="state" />
                      <app-form-error-component [control]="investorForm.controls['state']"></app-form-error-component>
                    </div>

                    <div class="mb-1 field-group width-120">
                      <label for="area" class="form-title"> Area</label>
                      <input type="text" maxlength="15" class="form-control" formControlName="area" id="area" />
                      <app-form-error-component [control]="investorForm.controls['area']" />
                    </div>

                    <div class="mb-1 field-group width-80">
                      <label for="zipCode" class="form-title text-nowrap"> <span class="required">*</span> Post code</label>
                      <input type="text" class="form-control" maxlength="9" formControlName="zipCode" id="zipCode" />
                      <app-form-error-component [control]="investorForm.controls['zipCode']"></app-form-error-component>
                    </div>

                    <div class="mb-1 field-group width-158">
                      <label for="country" class="form-title"> <span class="required">*</span> Country</label>
                      <div class="input-group">
                        <select class="custom-form-select border-radius-100" id="country" formControlName="country"
                                (change)="onSelectCountry($event)">
                          <option *ngFor="let country of countryList" [value]="country.name">
                            {{ country.name }}
                          </option>
                        </select>
                      </div>
                      <app-form-error-component [control]="investorForm.controls['country']"></app-form-error-component>
                    </div>

                    <div class="mb-1 field-group width-175">
                      <label for="home" class="form-title text-nowrap"> Home Phone</label>
                      <input type="text" appFormatPhone class="form-control text-left" formControlName="home" id="home" />
                      <app-form-error-component [control]="investorForm.controls['home']" />
                    </div>

                    <div class="mb-1 field-group width-175">
                      <label for="office" class="form-title text-nowrap"> Office Phone</label>
                      <input type="text" appFormatPhone class="form-control text-left" formControlName="office" id="office" />
                      <app-form-error-component [control]="investorForm.controls['office']" />
                    </div>

                    <div class="mb-1 field-group width-175">
                      <label for="mobile" class="form-title"> Mobile Phone</label>
                      <input type="text" appFormatPhone class="form-control text-left" formControlName="mobile" id="mobile" />
                      <app-form-error-component [control]="investorForm.controls['mobile']" />
                    </div>

                    <div class="mb-1 field-group width-120">
                      <label for="account" class="form-title">
                        <span class="required" *ngIf="isAccountRequired">*</span> Account
                      </label>
                      <input type="text"
                             class="form-control"
                             formControlName="account"
                             id="account"
                             style="text-transform: uppercase;"
                             appOnlyNumber
                             [allowedSign]="'none'"
                      />
                      <app-form-error-component [control]="investorForm.controls['account']" />
                    </div>

                    <div class="mb-1 field-group width-85">
                      <label for="sortCode" class="form-title text-nowrap"> <span class="required" *ngIf="isSortCodeRequired">*</span> Sort Code
                      </label>
                      <input type="text" maxlength="8" (input)="onSortCodeInput($event)" class="form-control sd-width" placeholder="" formControlName="sortCode" id="sortCode" />
                      <app-form-error-component [control]="investorForm.controls['sortCode']" />
                    </div>

                    <div class="mb-1 field-group width-90">
                      <label for="swift" class="form-title"><span class="required" *ngIf="isSwiftBicRequired">*</span> SWIFT BIC</label>
                      <input
                        id="swift"
                        type="text"
                        class="form-control ft-width"
                        placeholder=""
                        formControlName="swiftBic"
                        maxlength="8"
                        style="text-transform: uppercase;"
                      />
                      <app-form-error-component [control]="investorForm.controls['swiftBic']"></app-form-error-component>
                    </div>


                    <div class="mb-1 field-group width-230">
                      <label for="iban" class="form-title"><span class="required" *ngIf="isIbanRequired">*</span> IBAN</label>
                      <input
                        id="iban"
                        type="text"
                        class="form-control ft-width"
                        placeholder=""
                        formControlName="iban"
                        maxlength="34"
                        style="text-transform: uppercase;"
                      />
                      <app-form-error-component [control]="investorForm.controls['iban']" />
                    </div>
                  </div>
                  <div class="col-12 bottom-fixed">
                    <hr class="my-2" />
                    <div class="d-flex justify-content-center mt-3">
                      <button [disabled]="investorForm.invalid" type="submit"
                              class="btn btn-light me-3 btn-custom-footer save_btn">
                        Save
                      </button>
                      <button
                        type="button"
                        class="btn btn-light btn-custom-footer cancel_btn"
                        data-dismiss="modal"
                        (click)="closeModal()"
                      >
                        Cancel
                      </button>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>





